/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderDTO } from '../models/OrderDTO'
import type { PaginatedDTO_OrderDTO_ } from '../models/PaginatedDTO_OrderDTO_'
import type { TaskDTO } from '../models/TaskDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenOrdersService {
    /**
     * Index
     * @returns PaginatedDTO_OrderDTO_ Successful Response
     * @throws ApiError
     */
    public static indexOrdersGet({
        page = 1,
        limit = 10,
        patientId,
        sort
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Filter by patient_id
         */
        patientId?: string | null
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
    }): CancelablePromise<PaginatedDTO_OrderDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/orders',
            query: {
                page: page,
                limit: limit,
                patient_id: patientId,
                sort: sort
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get
     * @returns OrderDTO Successful Response
     * @throws ApiError
     */
    public static getOrdersOrderIdGet({ orderId }: { orderId: string }): CancelablePromise<OrderDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/orders/{order_id}',
            path: {
                order_id: orderId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Resend Notification
     * Resend the Greenlight notification email for a patient's order.
     *
     * The order lookup runs in the API tier (RLS-scoped to the caller's org, so a
     * cross-org ``order_id`` 404s). The origin call itself is dispatched to the
     * worker — which owns the ``ORIGIN_GREENLIGHT_*`` config/secret — and returns
     * a task id to poll (matches ``check_origin_greenlight_connectivity``). Poll
     * the task for ``{"ok": bool, "error"?}``. The worker audits the action only
     * once the resend actually succeeds. Rate-limited to 5/minute per order
     * (``_resend_rate_limit_key``) so one patient can't be spammed with emails.
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static resendNotificationOrdersOrderIdResendNotificationPost({ orderId }: { orderId: string }): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/orders/{order_id}/resend-notification',
            path: {
                order_id: orderId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
